<template>
  <header class="header" id="main-header">
    <b-navbar toggleable="lg" style="border-bottom:1px solid #d8d8d8;padding-top:0;padding-bottom:0;color:blue">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand>
        <img src="../assets/moowle-logo-big.png" width="100px" @click="navigateHome">
      </b-navbar-brand>
    </b-navbar>
  </header>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    methods: {
    }  
  };

</script>
<style scoped>

  .active {
    border-bottom: 2px solid #1f8efa;
  }

  #nav_collapse {
    line-height: 45px;
  }

  nav {
    color: blue;
  }
  .dropdown-item a{
    text-decoration: none;
  }

  .dropdown-item {
    outline: none;
  }


</style>



// WEBPACK FOOTER //
// src/components/HeaderBlank.vue